export const getCurrentScrollPercentage = () => {
  return Math.round(
    ((document.documentElement.scrollTop + document.body.scrollTop) /
      (document.documentElement.scrollHeight - document.documentElement.clientHeight)) *
      100,
  );
};
